<template>
  <div>
    <div v-if="permissions">
      <div class="card mb-4">
        <div class="card-header">
          Permisos disponibles
        </div>
        <div class="card-body">
          <div v-for="(permission, index) in permissions" :key="permission.id">
            <b-row>
              <!-- Atributos -->
              <b-col class="d-flex align-items-center">
                <!-- icon -->
                <i data-feather="key"></i>

                <div class="ml-4">
                  <div class="small">{{ permission.name }}</div>
                  <div class="text-xs text-muted">
                    {{ permission.description }}
                  </div>
                </div>
              </b-col>

              <!-- Controles -->
              <b-col>
                <b-container class="h-100 d-flex justify-content-end align-items-center">
                  <u-d-controls
                    :id="permission.id"
                    editPath="permissionModule/getPermission"
                    deletePath="permissionModule/deletePermission"
                    :editPermissions="['editar permisos']"
                    hideDeleteAction
                    @on-got-item="up"
                    class="my-2 justify-content-end"
                  />
                </b-container>
              </b-col>
            </b-row>
            <hr v-show="index < permissions.length - 1" />
          </div>
        </div>
      </div>
    </div>

    <loading v-else></loading>
  </div>
</template>

<script>
import UDControls from '@/components/Shared/UDControls'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'PermissionList',

  components: {
    UDControls
  },

  created () {
    this.getPermissions()
  },

  computed: {
    ...mapState('permissionModule', ['permissions'])
  },

  methods: {
    ...mapActions('permissionModule', ['getPermissions']),

    up () {
      window.scrollTo(0, 120)
    }
  }
}
</script>

<style lang="scss" scoped></style>
